"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calendar_add = void 0;
var calendar_add = {
  "viewBox": "0 0 64 64",
  "children": [{
    "name": "g",
    "attribs": {
      "id": "CALENDAR__x2F__ADD_1_",
      "enable-background": "new    "
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "CALENDAR__x2F__ADD"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "CALENDAR__x2F__ADD"
        },
        "children": [{
          "name": "g",
          "attribs": {},
          "children": [{
            "name": "g",
            "attribs": {},
            "children": [{
              "name": "path",
              "attribs": {
                "d": "M16,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C13,12.657,14.343,14,16,14z M25.126,31\r\n\t\t\t\tc-0.001,0-0.002,0-0.003,0h0.007C25.128,31,25.127,31,25.126,31z M48,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3\r\n\t\t\t\tv8C45,12.657,46.343,14,48,14z M25,44h4v4c0,1.657,1.343,3,3,3s3-1.343,3-3v-4h4c1.657,0,3-1.343,3-3s-1.343-3-3-3h-4v-4\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v4h-4c-1.657,0-3,1.343-3,3S23.343,44,25,44z M61,8h-6v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8\r\n\t\t\t\tH23v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H3c-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V11\r\n\t\t\t\tC64,9.343,62.657,8,61,8z M58,58H6V24h52V58z"
              },
              "children": [{
                "name": "path",
                "attribs": {
                  "d": "M16,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C13,12.657,14.343,14,16,14z M25.126,31\r\n\t\t\t\tc-0.001,0-0.002,0-0.003,0h0.007C25.128,31,25.127,31,25.126,31z M48,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3\r\n\t\t\t\tv8C45,12.657,46.343,14,48,14z M25,44h4v4c0,1.657,1.343,3,3,3s3-1.343,3-3v-4h4c1.657,0,3-1.343,3-3s-1.343-3-3-3h-4v-4\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v4h-4c-1.657,0-3,1.343-3,3S23.343,44,25,44z M61,8h-6v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8\r\n\t\t\t\tH23v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H3c-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V11\r\n\t\t\t\tC64,9.343,62.657,8,61,8z M58,58H6V24h52V58z"
                },
                "children": []
              }]
            }]
          }]
        }]
      }]
    }]
  }]
};
exports.calendar_add = calendar_add;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-icons-kit/ikons/calendar_add.js
// module id = 386
// module chunks = 0